<section class="stats" aria-label="آمار تصاویر">
  <div class="stat" *ngFor="let stat of stats" [attr.data-tone]="stat.tone">
    <span class="stat-icon" aria-hidden="true"><i class="fa" [ngClass]="stat.icon"></i></span>
    <div class="stat-content">
      <span class="stat-title">{{ stat.title }}</span>
      <strong>{{ stat.value | faNum }}</strong>
    </div>
  </div>
</section>
